// @flow
import React from 'react';
import { IconFilterItem } from 'components/atoms/iconFilterItem';
import type { PropertyTypeOption } from 'types/filter';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  activeFilters: Array<number>,
  toggleFilter: (option: any) => void,
  options: Array<PropertyTypeOption>,
};

export const PropertyTypeFilter = (props: Props) => {
  const { options, activeFilters = [], toggleFilter } = props;

  return (
    <div className={'property-type-filter filter'}>
      <h5 className={'filter-title'}>Property Type</h5>
      <div className={'filter-options'}>
        {options.map(option => {
          return (
            <IconFilterItem
              key={option.id}
              title={option.title}
              imageSrc={option.imageSource}
              onClick={() => toggleFilter(option)}
              isActive={activeFilters.indexOf(option.id) > -1}
            />
          );
        })}
      </div>
    </div>
  );
};
